import React from 'react';

import { Link } from 'react-router-dom';

import { CollectionLink } from '@pkg/components/Collections/CollectionLink.tsx';

import { AssetName, CollectionName, InfoHolder, Thumbnail, Wrapper } from './styles';

interface Props {
    image: string;
    name?: string;
    collection_slug?: string;
    collection_name?: string;
    asset_url: string;
}

export const AssetInfo = ({ image, name, collection_slug, collection_name, asset_url }: Props) => {
    return (
        <Wrapper>
            <Link to={asset_url}>
                <Thumbnail $image={image} />
            </Link>
            <InfoHolder>
                {name && (
                    <AssetName>
                        <Link to={asset_url}>{name}</Link>
                    </AssetName>
                )}
                {collection_name && (
                    <CollectionName>
                        <CollectionLink slug={collection_slug}>{collection_name}</CollectionLink>
                    </CollectionName>
                )}
            </InfoHolder>
        </Wrapper>
    );
};
